export const buyerSignUpFormText = {
    generalInformation: {
        title: 'General Information',
        topHeader: '1. General Information',
        sections: {
            buyerCompanyName: {
                header: '1.1 Buyer Company Name',
            },
            buyerCompanyAddress: {
                header: '1.2 Buyer Company Address',
            },
            salesContact: {
                header: '1.3 Sales Contact',
            },
            adminContact: {
                header: '1.4 Administrator Contact',
            },
            erp: {
                header: '1.5 ERP System',
            },
            maxSuppliers: {
                header: '1.6 Maximum number of suppliers',
            },
            maxInvoices: {
                header: '1.7 Maximum monthly number of invoices (transactions)',
            },
            oneCurrency: {
                header: "1.8 What currency will the buyer's invoices be billed in?",
            },
            trialEndDate: {
                header: '1.9 Trial period end date',
            },
        },
    },
    inboundDataFeeds: {
        title: 'Inbound Data Feeds',
        topHeader: '2. Inbound Data Feeds',
        sections: {
            deliveryMethod: {
                header: '2.1 Inbound data feeds will be delivered via',
            },
            infinxIntegration: {
                header: '2.2. Need to set up an Infinx (CloudCapture) integration for the buyer?',
            },
            infinxExistingConnection: {
                header: 'Share an existing Infinx (CloudCapture) SFTP connection?',
            },
            vendorFeedFormat: {
                header: '2.3 Manage vendors via automated feed?',
            },
            userFeedFormat: {
                header: '2.4 Manage users via automated feed?',
            },
            glAccountFeedFormat: {
                header: '2.5 Manage GL accounts via automated feed?',
            },
            poValidationFeedFormat: {
                header: '2.6 Manage POs for Validation via automated feed?',
            },
            poDeliveryFeedFormat: {
                header: '2.7 Manage POs for Delivery via automated feed?',
            },
        },
    },
    outboundDataFeeds: {
        title: 'Outbound Data Feeds',
        topHeader: '3. Outbound Data Feeds',
        sections: {
            deliveryMethod: {
                header: '3.1 Outbound data feeds will be delivered via',
            },
            fileType: {
                header: '3.2 What file types will be delivered?',
            },
        },
    },
    buyerSettings: {
        title: 'Buyer Settings',
        topHeader: '4. Buyer Settings',
        sections: {
            nextGenSupplierEnablement: {
                header: '4.1 Next Gen Supplier Enablement',
                subSections: {
                    nextGenSupplierEnablementOCR: {
                        header: 'Enable OCR',
                    },
                    nextGenSupplierEnablementIDETemplateMatching: {
                        header: 'IDE Template Matching',
                    },
                },
            },
            invoices: {
                header: '4.2 Invoices',
                subSections: {
                    invoicesEnableInvoices: {
                        header: 'Enable Invoices',
                    },
                    invoicesPOFlip: {
                        header: 'Enable PO Flip',
                    },
                    invoicesPOCloudMatching: {
                        header: 'PO CloudMatching',
                    },
                    invoicesPOCloudMatchingForceOneLine: {
                        header: 'Force invoices to match 1-line POs',
                    },
                },
            },
            posForDelivery: {
                header: '4.3 POs for Delivery',
                subSections: {
                    posForDeliveryEnable: {
                        header: 'Enable POs for delivery',
                    },
                },
            },
            poa: {
                header: '4.4 POAs',
                subSections: {
                    poaEnable: {
                        header: 'Enable POAs',
                    },
                },
            },
            asn: {
                header: '4.5 ASNs',
                subSections: {
                    asnEnable: {
                        header: 'Enable ASNs',
                    },
                },
            },
            workflow: {
                header: '4.6 Workflow',
                subSections: {
                    workflowParkingLot: {
                        header: 'Enable Parking Lot',
                    },
                    workflowReferencePO: {
                        header: 'Enable Reference Workflow for POs',
                    },
                    workflowReferenceNonPO: {
                        header: 'Enable Reference Workflow for Non-POs',
                    },
                    workflowCouldCode: {
                        header: 'Enable CloudCode',
                    },
                },
            },
            sim: {
                header: '4.7 SIM',
                subSections: {
                    simEnable: {
                        header: 'Enable SIM',
                    },
                },
            },
        },
    },
    submissionStatus: {
        success: (companyName?: string) => `Buyer company '${companyName ?? ''}' created successfully.`,
        successTitle: 'Success!',
        error: 'Error while trying to create the buyer company',
        loading: 'Creating buyer company...',
        reload: 'Create another buyer company',
    },
    form: {
        errorLoading: 'Error loading buyer company form',
    },
};
